import React, { Component } from 'react';
import { Grid, Switch } from '@material-ui/core';

class AppSettingsGeneral extends Component {
 
  generalSettings = () => {
    const settings = this.props.settings;
    const extensionDisabled = !settings.enabled;

    const extensionToggle = <Switch checked={settings.enabled} onChange={this.props.handleChange} color="primary" name="settings.enabled" />
    const generalSettings =
      <Grid item xs={12}>
        { this.props.createHeader("Meeting Cost App Configuration", "You can temporarily disabled the app here and the rest of general settings control how the app is showing the cost of the meetings.", extensionToggle)}          
        <Grid container spacing={1} className="ml-3">
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Use Currency Estimates", "You can choose to show currency based estimate, or by disabling this, show time cost estimate instead.")}
              <Grid item>
                <Switch checked={settings.showCurrency} disabled={extensionDisabled} onChange={this.props.handleChange} color="primary" name="settings.showCurrency" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Show Quarterly Estimates", "Show estimate of cost for recurring meetings when creating new meeting and when the recurrence rule is available for the existing event.")}
              <Grid item>
                <Switch checked={settings.show90day} disabled={extensionDisabled} onChange={this.props.handleChange} color="primary" name="settings.show90day" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Show Estimate Tooltip", "User can hover over the cost estimate and see the details how the estimate was created. Only available on Google Calendar.")}
              <Grid item>
                <Switch checked={settings.tooltip} disabled={extensionDisabled} onChange={this.props.handleChange} color="primary" name="settings.tooltip" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>;
      return generalSettings;
  }
  render() {
    if (this.props.loading)
      return this.props.loading();
    return this.generalSettings();
  }
}

export default AppSettingsGeneral;
